import React, { useEffect, useState } from 'react';
import axios from 'axios';

const ContactDetails = ({ email, mobile, address }) => (
  <div className="text-center mb-4">
    <h5>Contact Details</h5>
    <p className="text-muted">
      <a href={`mailto:${email}`} className="me-4">
        <i className="fa-solid fa-envelope me-1"></i>{email}
      </a>
      <a href={`tel:+${mobile}`} className="me-4">
        <i className="fa-solid fa-phone me-1"></i>{mobile}
      </a>
      <span className="me-4">
        <i className="fa-solid fa-location-crosshairs me-1"></i>{address}
      </span>
    </p>
  </div>
);
const Section = ({ title, children }) => (
  <div className="mb-4">
    <h4 className="text-primary">{title}</h4>
    {children}
  </div>
);
const MyResume = ({ userid }) => {
  const [resumeData, setResume] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  useEffect(() => {
    const fetchResume = async () => {
      try {
        setLoading(true)
        const url = process.env.REACT_APP_API_URL + `resume/getresumebyuser/${userid}`;
        const { data } = await axios.get(url);
        setResume(data[0]);
      } catch (err) {
        setError('Failed to fetch resume');
      } finally {
        setLoading(false);
      }
    };

    fetchResume();
  }, [userid]);

  

  if(loading){
    return(
    <div className="d-flex justify-content-center align-items-center my-4">
      <div className="spinner-border text-primary" role="status">
        <span className="visually-hidden">Loading...</span>
      </div>
    </div>
  );
}
  
  if(error){
    return(
    <div className="alert alert-danger text-center my-4" role="alert">
      {error}
    </div>
  );
}
if (!resumeData) {
  return <p>No resume data available.</p>;
}
const {
  name,
  designation,
  linkedinUrl,
  portfolioUrl,
  email,
  mobile,
  candidate_address,
  self_description,
  educationTitle,
  degree,
  institute,
  educationYear,
  educationDescription,
  skills,
  currentSalary,
  organization,
  jobDuration,
  jobLocation,
  jobDescription,
  projecttitle1,
  projectdescription1,
  projecttitle2,
  projectdescription2,
  dob,
  knownlanguage,
  maritalStatus,
} = resumeData;

  return (
    <div className="col-lg my-resume-container">
      <div className="container mt-1">
        <div className="card shadow-sm">
          <div className="card-body">
            <div className="d-flex justify-content-between align-items-center mb-4">
              <div>
                <h1 className="text-primary">{name}</h1>
                <h5 className="text-muted">{designation}</h5>
              </div>
              <div>
                <a href={linkedinUrl} target="_blank" rel="noopener noreferrer" className="btn btn-outline-primary me-2">
                  <i className="fa-brands fa-linkedin me-1"></i> LinkedIn
                </a>
                {portfolioUrl && (
                  <a href={portfolioUrl} target="_blank" rel="noopener noreferrer" className="btn btn-outline-secondary">
                    <i className="fa-solid fa-globe me-1"></i> Portfolio
                  </a>
                )}
              </div>
            </div>

            <div className="text-center mb-4">
              <h5>Contact Details</h5>
              <p className="text-muted">
                {/* <a href={`mailto:${resumeData.email}`} className="me-4">
                  <i className="fa-solid fa-envelope me-1"></i>{resumeData.email}
                </a> */}

                {/* <a href={`tel:+${resumeData.mobile}`} className="me-4">
                  <i className="fa-solid fa-phone me-1"></i> {resumeData.mobile}
                </a>
                <span className="me-4">
                  <i className="fa-solid fa-location-crosshairs me-1"></i>{resumeData.candidate_address}
                </span> */}

<ContactDetails email={email} mobile={mobile} address={candidate_address} />

<hr />
              </p>
            </div>

            <hr />

            <div className="mb-4">
            <h4 className="text-primary">Summary</h4>
            <div 
                className="resume-description" 
                dangerouslySetInnerHTML={{ __html: resumeData.self_description }} 
            />
        </div>

            <div className="mb-4">
              <h4 className="text-primary">Education</h4>
              <p>
                <strong>{educationTitle}</strong> in {degree}, {institute} ({educationYear})
              </p>
              <div 
                className="description" 
                dangerouslySetInnerHTML={{ __html: resumeData.educationDescription }} 
            />
            </div>

            <div className="mb-4">
              <h4 className="text-primary">Skills</h4>
              <p>{skills}</p>
            </div>

            <div className="mb-4">
              <div className="d-flex justify-content-between align-items-center">
                <h4 className="text-primary">Work Experience</h4>
                <span className="text-muted">Current Salary: {currentSalary} LPA</span>
              </div>
              <p>
                <strong>{organization}</strong> - {designation} <br />
                <span className="text-muted">Duration: {jobDuration} | Location: {jobLocation}</span>
                <br />
                <div 
                className="description" 
                dangerouslySetInnerHTML={{ __html: jobDescription }} 
            />
              </p>
            </div>

            <div className="mb-4">
              <h4 className="text-primary">Projects</h4>
              <div>
                <strong>{resumeData.projecttitle1}</strong>
                <div 
                className="description" 
                dangerouslySetInnerHTML={{ __html: projectdescription1 }} 
            />
              </div>
              <div>
                <strong>{projecttitle2}</strong>
                <div 
                className="description" 
                dangerouslySetInnerHTML={{ __html: projectdescription2 }} 
            />
              </div>
            </div>

            <div className="mb-4">
              <h4 className="text-primary mb-3">Additional Information</h4>
              <p>
                <strong>Date of Birth:</strong> {new Date(resumeData.dob).toLocaleDateString()} <br />
                <strong>Known Languages:</strong> {resumeData.knownlanguage} <br />
                <strong>Marital Status:</strong> {resumeData.maritalStatus === "1" ? "Married" : "Single"}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>

  );
};

export default MyResume;
